export const convertMetersInMiles: (meters: number) => string = (meters: number) => ((meters / 1000) * 0.621371).toFixed(2);

export const convertMilesInMeters: (miles: number) => number = (miles: number) => (miles * 1000) / 0.621371;
